var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"node-hover-onboarding-controls-buttons__button",on:{"click":_vm.applyColor}},[_c('div',{staticClass:"node-hover-onboarding-controls-buttons__colors-wrap"},[_c('div',{staticClass:"node-onboarding-palette-button__color",style:({
        backgroundColor: _vm.isUsingDark
          ? _vm.colorGroup.dark.background.value?.toString()
          : _vm.colorGroup.light.background.value?.toString()
      })}),_c('div',{staticClass:"node-onboarding-palette-button__color",style:({
        backgroundColor: _vm.isUsingDark
          ? _vm.colorGroup.light.background.value?.toString()
          : _vm.colorGroup.dark.background.value?.toString()
      })}),_c('div',{staticClass:"node-onboarding-palette-button__color",style:({
        backgroundColor: _vm.colorGroup.brand.background.value?.toString()
      })})])])
}
var staticRenderFns = []

export { render, staticRenderFns }